import { Modal, ListGroup, ListGroupItem } from "react-bootstrap";
import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

class MembersGenerateCoverageModal extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  getMemberString(member) {
      return `${member.firstName} ${member.lastName} / ${member.memberIdentifier} (${member.clientName})`;
  }

  render() {
    const {members} = this.props;
    return (
      <Modal show={this.props.showMembersModal} onHide={this.props.onClose}>
        <div className="modal-main">
          <Modal.Header>
            <Modal.Title><span className="member-coverage-confirmation-title"><FormattedMessage id="members.selectionsOfMembersForCoverageConfirmation"/></span></Modal.Title>
            <span className="close" onClick={this.props.onClose} />
          </Modal.Header>
          <Modal.Body>
            <ListGroup>
              {members && members.length > 0 ? (
                members.map((member) => {
                  return (
                    <ListGroupItem key={member.memberId}>
                      {this.getMemberString(member)}
                    </ListGroupItem>
                  );
                })
              ) : (
                <FormattedMessage id="members.noMembersSelected"/>
              )}
            </ListGroup>
          </Modal.Body>
        </div>
      </Modal>
    );
  }
}

MembersGenerateCoverageModal.propTypes = {
  members: PropTypes.array,
  showMembersModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MembersGenerateCoverageModal;


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/MembersGenerateCoverageModal.js